<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <div
      class="back-mobile-btn"
      @click="prevStep('questionnaire')"
    >
      <i class="fa fa-arrow-left" />
    </div>
    <h3>
      {{ $t('preCheckIn.questionnaire.title') }}
    </h3>
    <el-form
      :model="questionnaireData"
      label-position="top"
      class="questionnaire-form pre-reg"
      ref="questionnaire"
      autocomplete="off"
    >
      <SurveyComponent
        v-if="questionsData.length !== 0 && renderComponent"
        :data.sync="questionsData"
        :fields.sync="fields"
        @sendFields="sendFields"
        :index.sync="pageIndex"
        ref="surveyComp"
      />
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-buttons"
        >
          <el-button
            @click="prevStep('questionnaire')"
            type="back"
          >
            {{ $t('common.buttons.back') }}
          </el-button>
          <el-row
            class="right-btn"
          >
            <el-button
              type="primary"
              @click="nextStep('questionnaire')"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-row>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import store from "../../store";
import SurveyComponent from '../components/SurveyComponent';
import {DELIMITER, EQUAL_DELIMITER} from '../../utils/consts';

export default {
  name: "Questionnaire",
  components: {
    SurveyComponent
  },
  data: () => ({
    fullscreenLoading: false,
    userData: {},
    questionnaireData: {},
    questionsData: [],
    fields: [],
    validateFields: [],
    patientNumber: null,
    patientId: null,
    survey: null,
    pageIndex: 0,
    patientFindings: [],
    surveyFieldsData: [],
    renderComponent: true,
    activeStep: null,
    sid: null,
    languages: ['en', 'es'],
    locale: 'en',
    routerNextStep: 'SignDocuments',
    routerPrevStep: 'ReferringProvider',
  }),
  created () {
    let pathData = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    if (this.languages.includes(pathData[0])) this.locale = pathData[0];
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    this.sid = this.getSessionId();
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.patientNumber = store.getters.patientData.patientNumber;
        this.setData();
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    sendFields(data){
      this.validateFields = data
    },
    setData() {
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_Questionnaire : 'true'
      });
      this.userData = store.getters.patientData;
      this.patientNumber = this.userData.patientNumber;
      this.surveyFieldsData = store.getters.surveyData;
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      });
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
        pid: this.userData.patientId
      }).then((response) => {
        if (response.data) {
          if (response.data.appData) {
            this.$set(this.userData, 'reasonCode', response.data.appData.reasonCode);
            this.$set(this.userData, 'appointmentId', response.data.appData.appointmentId);
            this.GetQuestionnaire();
          }
        }
      }).catch(() => {
        this.setMessage(this.$t('common.errors.data'));
        this.fullscreenLoading = false;
      });
    },
    GetQuestionnaire() {
      return this.$axios('/PatientSurvey/GetQuestionnaire', {
        method: 'POST',
        data: {
          language: this.locale.toUpperCase(),
          reasonCode: this.userData.reasonCode,
          gender: this.userData.sex,
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data && response.data.data.length !== 0) {
            this.$set(this, 'questionsData', response.data.data);
          } else {
            this.$router.push({
              name: this.routerNextStep,
              params: {
                patientNumber: this.patientNumber,
                questionsData: false
              },
            });
          }
          this.fullscreenLoading = false;
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    },
    nextStep() {
      this.fullscreenLoading = true;
      let errors = this.$refs.surveyComp.sendValidateFields(this.validateFields)
      if (errors) {
        this.fullscreenLoading = false;
        return false
      } else {
        let fieldsArray = [];
        this.validateFields.forEach((value) => {
          fieldsArray.push(value);
        });
        if (this.surveyFieldsData.length !==0 ) {
          this.surveyFieldsData[this.pageIndex] = fieldsArray
          store.dispatch('updateSurveyData', this.surveyFieldsData);
        } else {
          store.dispatch('setSurveyData', fieldsArray);
        }

        this.pageIndex++;

        if (this.questionsData.length == this.pageIndex) {
          this.saveStatisticData(this.sid, {
            submit_Questionnaire: 'true'
          });
          let questionnaireFindingsData = [];
          this.surveyFieldsData.forEach((items) => {
            items.forEach((item) => {
              if (!Number.isInteger(item.findingId)) item.findingId = parseInt(item.findingId.replace('f',''));
              questionnaireFindingsData.push(item);
            });
          });
          this.$axios("/PatientSurvey/SavePatientFindings", {
            method: "POST",
            data: {
              appointmentId: this.userData.appointmentId,
              patientFindings: questionnaireFindingsData
            }
          }).then((response) => {
            if (response.data.isSuccess) {
              this.updateStepsData(this.userData.patientId, {[this.activeStep]: 1}).then((response) => {
                if (response.data.isSuccess) {
                  this.updateUserAppData(this.userData.patientId, {
                    patientFindings: questionnaireFindingsData
                  }).then((response) => {
                    if (response.data) {
                      if (response.data.isSuccess) {
                        this.fullscreenLoading = false;
                        this.$router.push({
                          name: this.routerNextStep,
                          params: {
                            patientNumber: this.patientNumber,
                            questionsData: true,
                            findingsData: questionnaireFindingsData
                          },
                        });
                      } else {
                        this.fullscreenLoading = false;
                        this.setMessage(
                          this.$t('common.errors.update', { type: this.$t('preCheckIn.questionnaire.data') }),
                          'warning'
                        );
                      }
                    } else {
                      this.fullscreenLoading = false;
                      this.setMessage(
                        this.$t('common.errors.update', { type: this.$t('preCheckIn.questionnaire.data') }),
                        'warning'
                      );
                    }
                  }).catch(() => {
                    this.setMessage(this.$t('common.errors.update', { type: this.$t('preCheckIn.questionnaire.data') }));
                    this.fullscreenLoading = false;
                  });
                } else {
                  this.fullscreenLoading = false;
                  this.setMessage(
                    this.$t('common.errors.update', { type: this.$t('preCheckIn.questionnaire.data') }),
                    'warning'
                  );
                }
              }).catch(() => {
                this.fullscreenLoading = false;
                this.setMessage(this.$t('common.errors.fail'));
              });
            } else {
              this.fullscreenLoading = false;
              this.setMessage(
                  this.$t('common.errors.update', { type: this.$t('preCheckIn.questionnaire.data') }),
                  'warning'
              );
            }
          }).catch(() => {
            this.fullscreenLoading = false;
            this.setMessage(this.$t('common.errors.fail'));
          });

        } else {
          let disabled = false,
              findingDisabling = this.questionsData[this.pageIndex].page.findingConditionForDisabling;
          if (findingDisabling) {

            disabled = this.isNotDisabled(findingDisabling, this.surveyFieldsData);
            if (!disabled) {
              this.pageIndex++;
            }
          }
          this.fullscreenLoading = false;
          this.forceRerender();
        }
      }
    },
    prevStep() {
      this.fullscreenLoading = true;
      if (this.pageIndex == 0) {
        this.goBack(this.routerPrevStep, 'questionnaire');
      } else {
        this.pageIndex--;
        let disabled = false,
            findingDisabling = this.questionsData[this.pageIndex].page.findingConditionForDisabling;
        if (findingDisabling) {
          disabled = this.isNotDisabled(findingDisabling, this.surveyFieldsData);
          if (!disabled) {
            this.pageIndex--;
          }
        }
        this.forceRerender();
        this.fullscreenLoading = false;
      }
    },
    isNotDisabled(findingConditionForDisabling, fieldsData) {
      let isNotDisabled = true;
      let findingsConditionsForDisabling = findingConditionForDisabling.split(DELIMITER);
      for (let k = 0; k < findingsConditionsForDisabling.length; k++) {
        let disablingFindingId = findingsConditionsForDisabling[k].split(EQUAL_DELIMITER)[0];
        let disablingFindingValue = findingsConditionsForDisabling[k].split(EQUAL_DELIMITER)[1];
        let disablingQuestion = this.findQuestionByFindingId(fieldsData, disablingFindingId);

        if (disablingQuestion && disablingFindingValue === disablingQuestion.yNResultFlag) {
          isNotDisabled = false;
        }
      }
      return isNotDisabled;
    },
    findQuestionByFindingId (fields, findingId) {
      let neededQuestion = null;
      fields.forEach(fragment => {
        let question = fragment.filter(question =>
          (question.findingId === findingId) || (!Number.isInteger(question.findingId) && question.findingId.includes(findingId))
        )
        if (question[0]) {
          neededQuestion = question[0];
          return true;
        }
      });
      return neededQuestion;
    }
  }
};
</script>
